import {
    createCommand,
    $getSelection,
    $isRangeSelection,
    $isTextNode,
    type TextNode,
} from 'lexical';

export const CLEAR_FORMATTING_COMMAND = createCommand('CLEAR_FORMATTING_COMMAND');

export function registerClearFormatting(editor: any) {
    return editor.registerCommand(
        CLEAR_FORMATTING_COMMAND,
        () => {
            editor.update(() => {
                const selection = $getSelection();
                if ($isRangeSelection(selection)) {
                    const extractedNodes = selection.extract();
                    for (const node of extractedNodes) {
                        if ($isTextNode(node)) {
                            (node as TextNode).setFormat(0);

                            (node as TextNode).setStyle('');
                        }
                    }
                }
            });
            return true;
        },
        0
    );
}
